import _ from 'lodash';
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faTimes } from '@fortawesome/free-solid-svg-icons';
import classnames from 'classnames';

import { SearchBarProps } from './SearchBarModel';

import './SearchBar.scss';
import i18n from 'i18n';

// This is internal state, no need to export
type SearchBarState = {
  readonly focused: boolean;
  readonly clearable: boolean;
  readonly keyword: string;
};

export class SearchBarInternalModel {
  focused: boolean;
  clearable: boolean;
  keyword: string;

  constructor(defaultValue?: string) {
    this.focused = false;
    this.clearable = !!defaultValue;
    this.keyword = defaultValue || '';
  }

  get state(): SearchBarState {
    return {
      focused: this.focused,
      clearable: this.clearable,
      keyword: this.keyword,
    };
  }

  onFocused(): SearchBarState {
    this.focused = true;
    return this.state;
  }

  onBlurred(): SearchBarState {
    this.focused = false;
    return this.state;
  }

  onChanged(keyword: string): SearchBarState {
    this.keyword = keyword;
    this.clearable = !_.isEmpty(keyword);
    return this.state;
  }

  onClear(): SearchBarState {
    this.keyword = '';
    this.clearable = false;
    return this.state;
  }
}

export class SearchBar extends React.Component<SearchBarProps, SearchBarState> {
  stateModel: SearchBarInternalModel;

  constructor(props: any) {
    super(props);
    this.stateModel = new SearchBarInternalModel(props.model.defaultValue);
    this.state = this.stateModel.state;
  }

  public focused = () => {
    this.setState(this.stateModel.onFocused());
  };

  public blurred = () => {
    this.setState(this.stateModel.onBlurred());
  };

  public changed = (e: React.ChangeEvent<HTMLInputElement>) => {
    const keyword = e.target.value;
    this.props.model.search(keyword);
    this.setState(this.stateModel.onChanged(keyword));
  };

  public clear = () => {
    this.props.model.search('');
    this.setState(this.stateModel.onClear());
  };

  public update = (keyword: string) => {
    this.props.model.search(keyword);
    this.setState(this.stateModel.onChanged(keyword));
  };

  render() {
    const classes = classnames('search-bar', {
      focused: this.state.focused,
      disabled: this.props.disabled,
    });
    const clearButtonClass = classnames({
      visible: this.state.clearable,
      invisible: !this.state.clearable,
    });
    return (
      <div className={classes}>
        <span>
          <FontAwesomeIcon icon={faSearch} />
        </span>
        <input
          type='text'
          value={this.state.keyword}
          onFocus={this.focused}
          onBlur={this.blurred}
          onChange={this.changed}
          placeholder={i18n.t<string>(this.props.model.placeholder)}
          disabled={this.props.disabled}
        />
        <span onClick={this.clear}>
          <FontAwesomeIcon className={clearButtonClass} icon={faTimes} />
        </span>
      </div>
    );
  }
}
